import React, { memo, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import Icon from '../../Icon';
import IconShareAndroid from '../../../public/static/images/webview/icon-share-android.svg';
import IconShareIOS from '../../../public/static/images/webview/icon-share-ios.svg';
import ArrowLeftIcon from '../../../public/static/images/webview/icon-arrow-left.svg';
import Bookmark from '../../Bookmark';
import BackButton from '../../BackButton';
import useScrollState from '../../../hooks/useScrollState';
import { useIphoneDetection } from '../../../hooks/useIphoneDetection';
import { useBridgeAPI } from '../../../bridge';
import { BackHistoryStorage } from '../../../utils/helpers/BackHistoryStorage';

const WebViewAdAppBar = memo(({ setFavorited, isBookmarked }) => {
  const { scrollY } = useScrollState();
  const router = useRouter();
  const isIphone = useIphoneDetection();
  const { share } = useBridgeAPI();

  const { id } = router.query;

  useEffect(() => {
    const backHistoryStorage = BackHistoryStorage.getBackHistoryStorage();
    if (!backHistoryStorage) {
      BackHistoryStorage.setBackHistoryStorage();
    }
  }, []);

  const onShareClickHandler = async () => {
    try {
      share({ url: window.location.href });
    } catch (e) {
      console.log('share operation has error: ', e.message);
    }
  };

  const getShareIcon = () => {
    if (isIphone) {
      return (
        <Icon
          indent={false}
          IconComponent={IconShareIOS}
          width={17}
          height={21}
        />
      );
    }
    return (
      <Icon
        indent={false}
        IconComponent={IconShareAndroid}
        width={16}
        height={19}
      />
    );
  };

  const progress = useMemo(() => {
    const END_POSITION = 180;
    const percentByPosition = 1 - (END_POSITION - scrollY) / END_POSITION;
    return Math.max(0, Math.min(percentByPosition, 1)).toFixed(2);
  }, [scrollY]);

  return (
    <div style={{ '--scroll-progress': progress }} className="app-bar-webview">
      <div className="app-bar-webview__button">
        <BackButton
          icon={ArrowLeftIcon}
          className="app-bar-webview__button-back"
        />
      </div>

      <div className="app-bar-webview--actions">
        <i
          role="button"
          tabIndex={-1}
          onKeyDown={onShareClickHandler}
          onClick={onShareClickHandler}
          className="app-bar-webview__button"
        >
          {getShareIcon()}
        </i>
        <div className="app-bar-webview__button">
          <Bookmark
            itemId={id || ''}
            isActive={isBookmarked}
            setFavorited={setFavorited}
            isWebView
          />
        </div>
      </div>
    </div>
  );
});

WebViewAdAppBar.displayName = `WebViewAdAppBar`;

WebViewAdAppBar.propTypes = {
  isButtonsVisible: PropTypes.bool,
  isBookmarked: PropTypes.bool,
  isFixedHeader: PropTypes.bool,
  setFavorited: PropTypes.func
};

export default WebViewAdAppBar;
